import { name as appName } from './../../package.json'

declare global {
  interface Window {
    dataLayer: PiwikEvent[]
  }
}

interface PiwikEvent {
  action: string
  name: string
}

function sendTrackerEvent(event: PiwikEvent) {
  if (window.dataLayer) {
    window.dataLayer.push(event)
  }
  // Log simplified events in development
  if (process.env.NODE_ENV === 'development') {
    const { action, name } = event
    const simplifiedEvent = { action, name }
    console.log('simplifiedEvent: ', simplifiedEvent)
  }
}

/**
 * Tracks user events. Please use kebab-case. Create a maximum of one subcategory by using dot.separation.
 *
 * @param {string} action - What happened (view, click, toggle, etc.), like a category of the event.
 * @param {string} name - The specific event.
 */
export function track(action: string, name: string) {
  const event = {
    event: 'piwik.event',
    app: appName,
    category: appName,
    action,
    name,
  }
  sendTrackerEvent(event)
}
